var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        noBackdropDismiss: true,
        position: "bottom",
        "content-classes": "panel mediator"
      },
      on: { hide: _vm.stopAll, show: _vm.hideLoading },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "div",
        { staticClass: "panel-header" },
        [
          _c("q-resize-observable", { on: { resize: _vm.onResize1 } }),
          _vm._v(" "),
          _c("div", { staticClass: "panel-title" }, [
            _c("span", [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]),
            _vm._v(" "),
            _c("small", { staticClass: "text-grey-6" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.fileName) +
                  ", " +
                  _vm._s(_vm._f("formatSize")(_vm.fileSize)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-warning" }, [
              _vm._v("\n        " + _vm._s(_vm.groupMessage) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("q-btn", {
            attrs: {
              title: "Отменить",
              color: "primary",
              icon: "clear",
              small: "",
              round: "",
              flat: ""
            },
            on: { click: _vm.doCancel }
          }),
          _vm._v(" "),
          _c("q-btn", {
            attrs: {
              disabled: !_vm.name,
              color: "positive",
              icon: "done",
              small: "",
              round: "",
              flat: "",
              title: "Вставить"
            },
            on: { click: _vm.doSave }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c(
            "div",
            [
              _c("q-resize-observable", { on: { resize: _vm.onResize2 } }),
              _vm._v(" "),
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.$v.name.$error,
                    "error-label": _vm._f("errorLabel")(_vm.$v.name)
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": "Название",
                      suffix: _vm.reqType === "file" ? _vm.ext : ""
                    },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row justify-between" },
                [
                  _vm.editableFormat
                    ? _c("q-btn", {
                        attrs: {
                          icon: "crop_rotate",
                          color: "primary",
                          small: "",
                          round: "",
                          flat: "",
                          title: "Обрезать/повернуть"
                        },
                        on: { click: _vm.doCropRotate }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          this.file && _vm.file.type.indexOf("image") === 0 && _vm.opened
            ? _c("pic-resize", {
                attrs: {
                  maxHeight: _vm.picMaxHeight,
                  url: _vm.url,
                  picIniSize: _vm.fileSize,
                  editableFormat: _vm.editableFormat,
                  maxQuality: _vm.maxQuality
                },
                model: {
                  value: _vm.blob,
                  callback: function($$v) {
                    _vm.blob = $$v
                  },
                  expression: "blob"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          this.file && _vm.file.type.indexOf("video") === 0
            ? _c("video", {
                style: { maxHeight: _vm.maxHeight },
                attrs: { src: _vm.url, controls: "", id: "v" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.file && _vm.file.type.indexOf("audio") === 0
            ? _c("audio", { attrs: { src: _vm.url, controls: "", id: "a" } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.slimShow
        ? _c("slim-cropper", {
            ref: "slim",
            attrs: { options: _vm.slimOptions, data: _vm.file }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5985542", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5985542","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media-inserter.vue
// module id = null
// module chunks = 